import React from 'react'

const BAutocomplete = ({label, fieldName, style, white, hidden, children}) => (
  <div className='bInput bAutocomplete' style={{display: hidden ? 'none' : undefined}}>
    {label && <label className='bInputLabel' htmlFor={fieldName}>{label}</label>}
    <div style={style} className={'bInputDiv' + (white ? ' white' : '')}>
      {children}
    </div>
  </div>
)

export default BAutocomplete
